import config from '../presets/config';

const { tablet, smallDesktop, largeDesktop } = config.responsive;

const kebabCase = (str: string) =>
	(str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g) || []).join('-').toLowerCase();

export interface DeviceBounds {
	min: number;
	max: number;
}

export interface DeviceSize {
	[key: string]: DeviceBounds;
}

let deviceSize: DeviceSize = {};
let rootElement: Window | HTMLElement;
export function setDeviceSize(sizes: DeviceSize): void {
	deviceSize = sizes;
}

export function setRootElement(root: Window | HTMLElement): void {
	rootElement = root;
}

export function ltDevice(name: string): boolean {
	if (rootElement instanceof Window) {
		return rootElement.innerWidth < deviceSize[name].min;
	}
	return rootElement.clientWidth < deviceSize[name].min;
}

export function lteDevice(name: string): boolean {
	if (rootElement instanceof Window) {
		return rootElement.innerWidth <= deviceSize[name].min;
	}
	return rootElement.clientWidth <= deviceSize[name].min;
}

export function gtDevice(name: string): boolean {
	if (rootElement instanceof Window) {
		return rootElement.innerWidth > deviceSize[name].max;
	}
	return rootElement.clientWidth > deviceSize[name].max;
}

export function gteDevice(name: string): boolean {
	if (rootElement instanceof Window) {
		return rootElement.innerWidth >= deviceSize[name].max;
	}
	return rootElement.clientWidth >= deviceSize[name].max;
}

export function notDevice(name: string): boolean {
	if (rootElement instanceof Window) {
		return rootElement.innerWidth < deviceSize[name].min || rootElement.innerWidth >= deviceSize[name].max;
	}
	return rootElement.clientWidth < deviceSize[name].min || rootElement.clientWidth >= deviceSize[name].max;
}

export function onlyDevice(name: string): boolean {
	if (rootElement instanceof Window) {
		return rootElement.innerWidth >= deviceSize[name].min && rootElement.innerWidth < deviceSize[name].max;
	}
	return rootElement.clientWidth >= deviceSize[name].min && rootElement.clientWidth < deviceSize[name].max;
}

export function allowDevices(names: string[]): boolean {
	for (const name of names) {
		if (onlyDevice(name)) {
			return true;
		}
	}
	return false;
}

export function denyDevices(names: string[]): boolean {
	for (const name of names) {
		if (onlyDevice(name)) {
			return false;
		}
	}
	return true;
}

export function getDeviceClassName(): string {
	for (const key in deviceSize) {
		if (onlyDevice(key)) {
			return kebabCase(`ym-device-${key}`);
		}
	}
	return kebabCase('ym-device-default');
}

export function getAllDeviceClassNames(): string[] {
	const results: string[] = [];
	// tslint:disable-next-line:forin
	for (const key in deviceSize) {
		results.push(kebabCase(`ym-device-${key}`));
	}
	return results;
}

export function ltTabletDevice(): boolean {
	return window.innerWidth < tablet.min;
}

export function gteTabletDevice(): boolean {
	return window.innerWidth >= tablet.max;
}

export function onlyTabletDevice(): boolean {
	return window.innerWidth >= tablet.min && window.innerWidth < tablet.max;
}

export function ltDeskopDevice(): boolean {
	return window.innerWidth < smallDesktop.min;
}

export function gteDesktopDevice(): boolean {
	return window.innerWidth >= smallDesktop.min;
}

export function ltLargeDeskopDevice(): boolean {
	return window.innerWidth < largeDesktop.min;
}

export function onlyDesktopDevice(): boolean {
	return window.innerWidth >= smallDesktop.min && window.innerWidth < smallDesktop.max;
}

export function gteLargeDesktopDevice(): boolean {
	return window.innerWidth >= largeDesktop.max;
}

export function callIfMobile(action: () => void): void {
	if (ltTabletDevice()) {
		action();
	}
}
